<template >
  <div id="inspire" >
    <v-layout>
      <v-card  style="background: #EFEFEF!important; width: 100%; border-radius: 0px" flat>
          <v-toolbar theme="dark"  color="#00295C" style=" padding-left: 1%; padding-right: 1%; position: fixed" >
            <v-row justify="space-between" no-gutters>
              <v-col cols="12" sm="8" md="6" lg="8" class="txt_toolbar">
                <v-icon small>mdi-map-marker</v-icon>

                <a href="https://www.google.com.br/maps/place/R.+Dep.+D%C3%AAnio+Moreira+de+Carvalho,+743+-+A+Definir,+Caratinga+-+MG,+35300-181/@-19.7836939,-42.1518587,17z/data=!3m1!4b1!4m5!3m4!1s0xba90c8d703458d:0x71520ce03a39a87c!8m2!3d-19.783699!4d-42.14967?hl=pt-BR" target="_blank" style="text-decoration: none; color: white">
                  Rua Dep. Dênio Moreira de Carvalho, 743 - Santa Cruz, Caratinga - MG</a>

              </v-col>
              <v-col cols="12" sm="4" md="6" lg="3"  class="txt_toolbar">
                  <a target="_blank" href="https://pt-br.facebook.com/casasantoscaratinga/"
                         style="text-decoration: none; padding-right: 5%">
                    <v-icon color="white" size="large">mdi-facebook</v-icon>
                  </a>
                 <v-icon>mdi-phone</v-icon>
                    <a href="tel:3333211340" target="_blank" style="text-decoration: none; color: white">(33)3321-1340</a>
              </v-col>
            </v-row>
          </v-toolbar>
        <v-sheet style="height: 100%">
          <div>
            <router-view/>
          </div>
        </v-sheet>
      </v-card>
    </v-layout>
  </div>
</template>

<script async>
  /* eslint-disable */

  export default {
    name: 'Dash',
    data: () => ({
    }),

    methods: {
    },
    components: {
    },
    mounted() {
    },
    computed: {
    },
  }
</script>
<style scoped lang="scss">
</style>
